"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Props = {
  label: _propTypes.default.string,
  header: _propTypes.default.string,
  counter: _propTypes.default.number,
  bsClass: _propTypes.default.string,
  bsId: _propTypes.default.string.isRequired,
  style: _propTypes.default.object,
  filters: _propTypes.default.arrayOf(_propTypes.default.object),
  filterUI: _propTypes.default.object.isRequired,
  toggleFilter: _propTypes.default.func.isRequired
};

var HOCFilter = function HOCFilter(_ref) {
  var filters = _ref.filters,
      label = _ref.label,
      style = _ref.style,
      counter = _ref.counter,
      header = _ref.header,
      _ref$bsClass = _ref.bsClass,
      bsClass = _ref$bsClass === void 0 ? 'bz-hoc-filter' : _ref$bsClass,
      bsId = _ref.bsId,
      toggleFilter = _ref.toggleFilter,
      isFilterOpen = _ref.filterUI.isFilterOpen,
      color = _ref.color;
  var clsFilter = (0, _classnames.default)(bsClass, 'dropdown');
  var clsIcon = (0, _classnames.default)('fa icon-AgendaAtt_filter', {
    'custom-color color-1': !isFilterOpen
  });
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown, {
    bsClass: clsFilter,
    id: bsId,
    open: isFilterOpen,
    onToggle: toggleFilter
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Toggle, {
    style: style
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: clsIcon,
    style: {
      color: color
    }
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "hidden-xs margin-horizontal-small filter-label"
  }, counter, " ", label)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Menu, null, header && /*#__PURE__*/_react.default.createElement(_reactBootstrap.MenuItem, {
    header: true
  }, header), filters.map(function (filter, index) {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: index
    }, filter.renderer(filter.props));
  })));
};

HOCFilter.propTypes = Props;
var _default = HOCFilter;
exports.default = _default;